import { useContext } from 'react';
import errorContext from './errorContext';

const useErrorState = () => {
    const context = useContext(errorContext);

    if (!Object.keys(context).length) {
        throw new Error('ErrorContext must be used within its provider');
    }

    return context;
};

export default useErrorState;
